export * from './new-precio.component';
export * from './entrega-dialog.component';
export * from './entregas-ocultas-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/new-precio/index.ts